export default (riskFactors, {id, category, rationale}) => {
	const {itRiskFactors, ...rest} = riskFactors;

	return {
		...rest,
		itRiskFactors: itRiskFactors.map((item) => {
			if (item.itRiskFactorId === id) {
				return {
					...item,
					isRejected: true,
					isRationaleEmpty: false,
					rationale: rationale ?? '',
					rationaleTypeId: category
				};
			}
			return item;
		})
	};
};
